import { Dispatch, SetStateAction, useCallback, useState } from 'react'
import { getUserSetting, updateUserSetting } from 'src/app/shared/services/UserSettingService'
import { IColumnSetting, IGetColumnSettingPayload, IPostColumnSettingPayload } from './table-setting.model'

export interface IUserSettingHook {
  userSetting: Array<IColumnSetting>
  isGettingSetting: boolean
  isUpdatingSetting: boolean
  setUserSetting: Dispatch<SetStateAction<Array<IColumnSetting>>>
  getSetting: (payload: IGetColumnSettingPayload) => Promise<Array<IColumnSetting>>
  updateSetting: (payload: IPostColumnSettingPayload) => Promise<Array<IColumnSetting>>
}

export const useUserSetting = (): IUserSettingHook => {
  const [userSetting, setUserSetting] = useState<Array<IColumnSetting>>([])
  const [isGettingSetting, setIsGettingSetting] = useState<boolean>(false)
  const [isUpdatingSetting, setIsUpdatingSetting] = useState<boolean>(false)

  const getSetting = useCallback(async (payload: IGetColumnSettingPayload) => {
    try {
      setIsGettingSetting(true)
      const data = await getUserSetting(payload)
      if (data.data && data.data.length > 0) {
        setUserSetting(data.data)
      }
      return data.data
    } catch (error) {
      console.log('ERROR: ', error)
      return []
    } finally {
      setIsGettingSetting(false)
    }
  }, [])

  const updateSetting = useCallback(async (payload: IPostColumnSettingPayload) => {
    try {
      setIsUpdatingSetting(true)
      const data = await updateUserSetting(payload)
      if (data.data && data.data.length > 0) {
        setUserSetting(data.data)
      }
      return data.data
    } catch (error) {
      console.log('ERROR: ', error)
      return []
    } finally {
      setIsUpdatingSetting(false)
    }
  }, [])

  return {
    userSetting,
    isUpdatingSetting,
    isGettingSetting,
    setUserSetting,
    getSetting,
    updateSetting,
  }
}